/**
 * LCV Lighthouse CrossFrame Listeners
 *
 * Handles CrossFrame requests for Lighthouse task management operations.
 * Validates required parameters and delegates to the Gateway client via getServiceClient().
 *
 * 4 listeners mapping to IhmLighthouseService operations:
 * - getTasksByParentTaskId
 * - startWorkOnTaskBatch
 * - stopWorkOnTask
 * - updateTask
 */

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import {
    GetTasksByParentTaskIdInput,
    GetTasksByParentTaskIdOutput,
    StartWorkOnTaskBatchInput,
    StartWorkOnTaskBatchOutput,
    StopWorkOnTaskInput,
    UpdateTaskInput,
    UpdateTaskOutput,
} from '@amzn/coral_com-amazon-ihmlighthouse'
import { validateRequired, validateRequiredArray } from './listenerUtils'

export async function getTasksByParentTaskIdListener (message: any): Promise<GetTasksByParentTaskIdOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId', 'parentTaskId')
    const client = getServiceClient()
    return client.getTasksByParentTaskId(GetTasksByParentTaskIdInput.clone(params)).toPromise()
}

export async function startWorkOnTaskBatchListener (message: any): Promise<StartWorkOnTaskBatchOutput> {
    const params = (message && message.data) || {}
    validateRequiredArray(params, 'startWorkOnTaskBatch')
    const client = getServiceClient()
    return client.startWorkOnTaskBatch(StartWorkOnTaskBatchInput.clone(params)).toPromise()
}

export async function stopWorkOnTaskListener (message: any): Promise<void> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId', 'taskId')
    const client = getServiceClient()
    return client.stopWorkOnTask(StopWorkOnTaskInput.clone(params)).toPromise()
}

export async function updateTaskListener (message: any): Promise<UpdateTaskOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId', 'taskId')
    const client = getServiceClient()
    return client.updateTask(UpdateTaskInput.clone(params)).toPromise()
}
